module.exports = __webpack_public_path__ + "static/media/Software3.ef518d37.png";